// extracted by mini-css-extract-plugin
export default {"detail":"Promotion_detail__s3lXz"};